import { defineSchema } from '../../schema-meta.ts';
import { registerCategorySchema } from '../../registry.ts';
import { parseIsoToEpochMs } from '../../../time-utils.ts';

// 시즌 메타(스케줄)만 — 전투 config(waves/enemies)는 serverValhallas 에 있고
// valhallaTableId 로 참조한다. 리그/디젠 시즌 테이블과 동형. 랭킹/보상 없음.
export const ValhallaSeasonSchema = defineSchema({
  name: 'serverValhallaSeasons',
  fields: [
    ['id', 'number'],
    ['startTime', 'number'], // epoch ms
    ['endTime', 'number'], // epoch ms
    ['valhallaTableId', 'number'],
  ],
  lookupKeys: ['id'],
});

export interface RawValhallaSeasonRow {
  id: number;
  start_time: string;
  end_time: string;
  valhalla_table_id: number;
}

export function valhallaSeasonFromRaw(row: RawValhallaSeasonRow) {
  return {
    id: row.id,
    startTime: parseIsoToEpochMs(row.start_time),
    endTime: parseIsoToEpochMs(row.end_time),
    valhallaTableId: row.valhalla_table_id,
  };
}

registerCategorySchema('serverValhallaSeasons', ValhallaSeasonSchema);
